import { Employee } from "../employee-list";
import React from "react";
import imgSolveigWindt from ".././media/solveig-windt.jpg";
import i18n from "../../../generic/i18n";

export const solveigWindt: Employee = {
  slug: "solveig-windt",
  displayName: "Solveig Windt",
  title: "student-assistant-female",
  hasProfile: false,
  isExternal: false,
  subTitle: "",
  awards: [],
  img: imgSolveigWindt,
  languages: ["deu", "eng"],
};
